import { Box, Container, Grid2 as Grid, IconButton, Link, Stack, styled, Typography } from "@mui/material"
import { forMembers, forSpecialists, legal, quickLinks, socialMediaLinks, support } from "./data"
import { Link as NLink } from "react-router-dom"
import Images from "../../../assets/js/Images"
import NavLink from "./NavLink"
import { checkUserType } from "../../../utils/helper"

const Image = styled("img")(() => ({}))
function Footer() {
  const userType = checkUserType();
  const filteredQuickLinks = userType === "specialist"
    ? quickLinks.filter(link => link.name !== "Pricing")
    : quickLinks;

  return (
    <Box
      component="footer"
      bgcolor="other.color1"
      color="white"
      sx={{
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
      }}
    >
      <Box
        sx={{
          py: 5,
          borderBottom: "1px solid #ffffff29"
        }}
      >
        <Container maxWidth={false} fixed>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6, lg: 3 }}>
              <Typography
                sx={{
                  mb: 1,
                  fontSize: "20px",
                  fontWeight: "700"
                }}
              >For Members
              </Typography>
              <Stack spacing={0.7} alignItems="start">
                {forMembers?.map((menu, i) => (
                  <NavLink key={i} menu={menu} />
                ))
                }
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 6, lg: 3 }}>
              <Typography
                sx={{
                  mb: 1,
                  fontSize: "20px",
                  fontWeight: "700"
                }}
              >For Specialists
              </Typography>
              <Stack spacing={0.7} alignItems="start">
                {forSpecialists?.map((menu, i) => (
                  <NavLink key={i} menu={menu} />
                ))
                }
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 6, lg: 3 }}>
              <Typography
                sx={{
                  mb: 1,
                  fontSize: "20px",
                  fontWeight: "700"
                }}
              >Quick Links
              </Typography>
              <Stack spacing={0.7} alignItems="start">
                {filteredQuickLinks?.map((menu, i) => (
                  <NavLink key={i} menu={menu} />
                ))
                }
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 6, lg: 3 }}>
              <Typography
                sx={{
                  mb: 1,
                  fontSize: "20px",
                  fontWeight: "700"
                }}
              >Support
              </Typography>
              <Stack spacing={0.7} alignItems="start">
                {support?.map((menu, i) => (
                  <NavLink key={i} menu={menu} />
                ))
                }
              </Stack>
              <Typography
                sx={{
                  mt: 3,
                  mb: 1,
                  fontSize: "20px",
                  fontWeight: "700"
                }}
              >Legal
              </Typography>
              <Stack spacing={0.7} alignItems="start">
                {legal?.map((menu, i) => (
                  <NavLink key={i} menu={menu} />
                ))
                }
              </Stack>
            </Grid>
            
          </Grid>
        </Container>
      </Box>
      <Box sx={{ py: 3 }}>
        <Container maxWidth="xxl">
          <Box
            sx={{
              gap: 1,
              display: "flex",
              alignItems: "center",
              flexDirection: { xs: "column", lg: "row" },
              justifyContent: { xs: "center", lg: "space-between" },
            }}
          >
            <Link
              to="/"
              component={NLink}
              sx={{ display: "inline-block" }}
            >
              <Image
                sx={{
                  width: "100%",
                  height: "50px",
                  minWidth: "180px",
                  objectFit: "contain"
                }}
                alt="logo"
                src={Images?.whiteLogo}
              />
            </Link>
            <Typography
              fontSize="15px"
            >&copy; {new Date().getFullYear()} InnerPal. All rights reserved.
            </Typography>
            <Stack
              spacing={0.5}
              direction="row"
              alignItems="center"
            >
              <Typography
                fontSize="20px"
              >Follow Us
              </Typography>
              {socialMediaLinks?.map((media, i) => (
                <IconButton
                  sx={{
                    color: "white",
                    fontSize: "20px",
                    transition: "all 350ms ease",
                    ":hover": { color: "secondary.dark" }
                  }}
                  key={i}
                  size="small"
                  target="_blank"
                  to={media?.path}
                  LinkComponent={NLink}
                >{media?.icon}
                </IconButton>
              ))
              }
            </Stack>
          </Box>
        </Container>
      </Box>
    </Box>
  )
}

export default Footer